import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";

import logo from "@/assets/logo-white.png";

const Footer = () => {
  return (
    <footer className="relative overflow-hidden border-t border-white/10 bg-[linear-gradient(180deg,hsl(222_24%_10%),hsl(222_24%_8%))] py-16 md:py-20">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_18%_20%,hsl(206_90%_58%/0.12),transparent_28%)]" />

      <div className="container relative mx-auto px-4">
        <div className="grid gap-12 border-b border-white/10 pb-12 text-center md:grid-cols-[minmax(0,1fr)_auto] md:items-end md:text-left">
          <div className="mx-auto max-w-2xl md:mx-0">
            <img
              src={logo}
              alt="BETON2GO by Romano"
              width={266}
              height={64}
              loading="lazy"
              decoding="async"
              className="mx-auto h-10 w-auto md:mx-0"
            />
            <p className="mt-6 font-display text-3xl uppercase leading-none text-foreground md:text-4xl">
              Bereit, wenn auf der Baustelle
              <br />
              Material sofort gebraucht wird.
            </p>
            <p className="mx-auto mt-5 max-w-xl text-sm leading-relaxed text-muted-foreground md:mx-0 md:text-base">
              Beton2Go by Romano steht für schnelle Verfügbarkeit, klare Preise und einen Ablauf,
              der auch bei kleinen Mengen wirtschaftlich bleibt.
            </p>
          </div>

          <div className="space-y-4">
            <div className="space-y-3 text-sm text-muted-foreground">
              <a href="tel:+4915141315272" className="flex items-center justify-center gap-3 hover:text-foreground md:justify-start">
                <Phone className="h-4 w-4 text-primary" />
                0151 41315272
              </a>
              <a href="mailto:info@beton2go-romano.de" className="flex items-center justify-center gap-3 hover:text-foreground md:justify-start">
                <Mail className="h-4 w-4 text-primary" />
                info@beton2go-romano.de
              </a>
              <a
                href="https://maps.google.com/?q=Primsaue+5+66809+Nalbach"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-3 hover:text-foreground md:justify-start"
              >
                <MapPin className="h-4 w-4 text-primary" />
                Primsaue 5, 66809 Nalbach
              </a>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center gap-6 pt-8 text-center md:flex-row md:justify-between md:text-left">
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-muted-foreground md:justify-start">
            <Link to="/impressum" className="transition-colors hover:text-foreground">
              Impressum
            </Link>
            <Link to="/datenschutz" className="transition-colors hover:text-foreground">
              Datenschutz
            </Link>
            <Link to="/cookies" className="transition-colors hover:text-foreground">
              Cookies
            </Link>
          </div>

          <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground">
            © {new Date().getFullYear()} Beton2Go by Romano
          </p>
        </div>

        <div className="mt-8 flex justify-center border-t border-white/5 pt-6">
          <a
            href="https://nico-saia.com"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-1.5 text-xs tracking-wide text-muted-foreground/70 transition-colors hover:text-foreground"
          >
            Made with
            <span className="text-[hsl(0_85%_55%)] transition-transform group-hover:scale-110" aria-hidden="true">♥</span>
            by
            <span className="font-medium text-muted-foreground group-hover:text-primary">nico-saia.com</span>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
